<template>
  <BaseShareControl
    text
    retain-focus-on-click
    :icon-disabled="iconDisabled"
    :ripple="false"
    color="white"
  >
    <span class="context-menu-text-item">
      {{ $t('Context.short.socialShare') }}
    </span>
  </BaseShareControl>
</template>

<script>
import BaseShareControl from '@/components/controls/BaseShareControl/BaseShareControl';

export default {
  name: 'SocialSharingControl',
  components: { BaseShareControl },
  props: {
    iconDisabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>
